import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const GeneralLedger = () => {
    return <AdminModulePage moduleKey="general-ledger" />;
};

export default GeneralLedger;
